import { gql } from "@apollo/client";

export const DO_NOT_CONTACT_REQUEST_FIELDS = gql`
  fragment DoNotContactRequestFields on DoNotContactRequest {
    id
    phoneNumber
    action
    contactName
    contactEmail
    notes
    createdAt
    createdByStaffEmail
    sourceType
  }
`;

export const LIST_DO_NOT_CONTACT_REQUESTS = gql`
  ${DO_NOT_CONTACT_REQUEST_FIELDS}
  query ListDoNotContactRequests($input: ListDoNotContactRequestsInput!) {
    listDoNotContactRequests(input: $input) {
      records {
        ...DoNotContactRequestFields
      }
      totalCount
    }
  }
`;

export const LIST_DO_NOT_CONTACT_REQUEST_HISTORY_FOR_PHONE_NUMBER = gql`
  ${DO_NOT_CONTACT_REQUEST_FIELDS}
  query ListDoNotContactRequestHistoryForPhoneNumber(
    $input: ListDoNotContactRequestHistoryForPhoneNumberInput!
  ) {
    listDoNotContactRequestHistoryForPhoneNumber(input: $input) {
      ...DoNotContactRequestFields
    }
  }
`;

export const CREATE_DO_NOT_CONTACT_REQUEST = gql`
  ${DO_NOT_CONTACT_REQUEST_FIELDS}
  mutation CreateDoNotContactRequest($input: CreateDoNotContactRequestInput!) {
    createDoNotContactRequest(input: $input) {
      ...DoNotContactRequestFields
    }
  }
`;
